// extracted by mini-css-extract-plugin
export default {"navLink":"NavItem_navLink__GndWI","active":"NavItem_active__pzGi6","navIcon":"NavItem_navIcon__mQdu-"};